
<div class="header-element mt-[5px] py-[1rem] md:px-[0.65rem] px-2  header-country [--placement:bottom-left]">
  <div class="hs-dropdown ti-dropdown ">
    <button id="dropdown-flag" type="button"
    class="hs-dropdown-toggle ti-dropdown-toggle !p-0 flex-shrink-0 !border-0 !rounded-full !shadow-none">
    <img
      [src]="getFlag(selectedLang)"
      alt="flag-img"
      class="h-[1.25rem] w-[1.25rem] rounded-full">
  </button>
    <div class="hs-dropdown-menu ti-dropdown-menu min-w-[10rem] hidden !-mt-3" aria-labelledby="dropdown-flag">
      <div class="ti-dropdown-divider divide-y divide-gray-200 dark:divide-white/10">
        <div class="py-2 first:pt-0 last:pb-0">
          <div *ngFor="let lang of languages"
               class="ti-dropdown-item !p-[0.65rem] cursor-pointer"
               (click)="selectLanguage(lang.code)">
            <div class="flex items-center space-x-2 rtl:space-x-reverse w-full">
              <div class="h-[1.375rem] flex items-center w-[1.375rem] rounded-full">
                <img [src]="lang.flag"
                     alt="flag-img"
                     class="h-[1rem] w-[1rem] rounded-full">
              </div>
              <div>
                <p class="!text-[0.8125rem] font-medium">
                  {{ lang.label | translate | capitalize }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>